<script setup>
/*
    Event widget - Display top alert events

    Components:
        primary: <v-list>

    Widget Properties:
        value # from alerts table

    CSS Properties:
        color | Color of the event text
        font-size | Font size of the event text
 */
import {reactive, ref} from 'vue'
import {State, clone} from '@/paks/vu-app'
import Dates from '@/paks/js-dates'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
    max: props.widget.max || MaxEvents,
    events: [],
})

const primary = ref(null)

const MaxEvents = 7

function update() {
    Object.assign(page, getWidgetProps(props.widget, {primary}))

    page.events = clone(page.data.primary || [])
    if (Array.isArray(page.events) && page.events.length) {
        page.events = page.events.slice(0, page.max)
        for (let event of page.events) {
            event.timestamp = Dates.format(event.timestamp, State.config.formats.time)
            if (event.severity == 'error') {
                event.icon = '$error'
            } else if (event.severity == 'warn' || event.severity == 'warning') {
                event.icon = '$warn'
            } else {
                event.icon = '$info'
            }
        }
    }
}

function click(event) {}
</script>

<template>
    <v-list dense ref="primary" class="event-widget" @click="click">
        <v-list-item v-for="(event, i) in page.events" :key="event.id" @click="click(event)">
            <v-icon :icon="event.icon" :class="`severity-${event.severity}`" size="x-large" />
            <span class="content">
                {{ event.subject }}
            </span>
        </v-list-item>
    </v-list>
</template>

<style lang="scss" scoped>
@use 'sass:color';
.event-widget {
    width: 100%;
    display: block;
    width: 100%;
    padding: 16px;
    .v-list-item {
        padding: 0;
        font-size: var(--v-font-size) !important;
        min-height: 34px !important;
        margin: 0;
        .v-icon {
            padding: 4px 8px 0 0 !important;
            vertical-align: bottom;
            &.severity-info {
                color: green;
            }
            &.severity-warn {
                color: orange;
            }
            &.severity-error {
                color: red;
            }
            &.severity-critical {
                color: red;
            }
        }
        .content {
            padding: 0 !important;
            margin-top: 8px;
            margin-bottom: 0px !important;
        }
        &:not(:last-child) {
            border-bottom: 1px solid color.adjust(gray, $lightness: 40%);
        }
    }
}
</style>
